module.exports = __webpack_public_path__ + "static/sidemail-08e3f083dade9eb1b79dcdb39ffad0ad.png";